(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["collection-banner"] && !Shopify.designMode) return;
  try {
    (function () {
    function getColumnCount(grid) {
      const tracks = window.getComputedStyle(grid).gridTemplateColumns;
      return tracks.split(/\s+/).filter(Boolean).length || 1;
    }

    function positionAllBanners() {
      const grid = document.querySelector('.product-grid');
      if (!grid) return;

      const colCount = getColumnCount(grid);

      // Sort banners ascending by row so earlier ones don't displace later ones
      const banners = [...grid.querySelectorAll('.product-grid__banner')];
      banners.sort((a, b) => (parseInt(a.dataset.bannerRow) || 0) - (parseInt(b.dataset.bannerRow) || 0));

      for (const banner of banners) {
        const rowIndex = parseInt(banner.dataset.bannerRow, 10) || 1;
        // Re-query after each insertion so product item indices stay accurate
        const items = [...grid.querySelectorAll('.product-grid__item:not(.product-grid__banner)')];
        grid.insertBefore(banner, items[rowIndex * colCount] || null);
      }
    }

    let resizeTimer;
    document.addEventListener('DOMContentLoaded', positionAllBanners);
    window.addEventListener('resize', function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(positionAllBanners, 200);
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["wishlist-power-button"] && !Shopify.designMode) return;
  try {
    // Pop the heart when a click adds the product, and slide in whichever label the app shows next.
  document.addEventListener(
    'click',
    (event) => {
      const control = event.target instanceof Element && event.target.closest('.wishlist-power-button__control');
      if (!control) return;

      const isAdding = control.getAttribute('aria-checked') !== 'true';
      control.classList.remove('wishlist-power-button__control--added', 'wishlist-power-button__control--removed');
      void control.offsetWidth;
      // The class stays until the next click so the label still animates when the app flips it after its request.
      control.classList.add(isAdding ? 'wishlist-power-button__control--added' : 'wishlist-power-button__control--removed');
    },
    { capture: true }
  );
  } catch(e) { console.error(e); }
})();

})();
